// AUTO-GENERATED by scripts/sync-pillar-index.mjs — do not edit by hand.
// Country → researched pillar guides (slug + topic), so homepages can link them.
export const MARKET_PILLARS = {
  "AT": [
    {
      "slug": "fuehrerschein-kosten-oesterreich",
      "topic": "cost"
    },
    {
      "slug": "pruefungsstrecken",
      "topic": "routes"
    }
  ],
  "AU": [
    {
      "slug": "cost-of-drivers-licence-australia",
      "topic": "cost"
    },
    {
      "slug": "driving-test-routes",
      "topic": "routes"
    }
  ],
  "BE": [
    {
      "slug": "rijbewijs-kosten-belgie",
      "topic": "cost"
    },
    {
      "slug": "examenparcours",
      "topic": "routes"
    }
  ],
  "CA": [
    {
      "slug": "drivers-licence-cost-canada",
      "topic": "cost"
    },
    {
      "slug": "road-test-routes",
      "topic": "routes"
    }
  ],
  "CH": [
    {
      "slug": "fuehrerausweis-kosten-schweiz",
      "topic": "cost"
    },
    {
      "slug": "pruefungsstrecken",
      "topic": "routes"
    }
  ],
  "DE": [
    {
      "slug": "fuehrerschein-kosten",
      "topic": "cost"
    },
    {
      "slug": "pruefungsstrecken",
      "topic": "routes"
    }
  ],
  "DK": [
    {
      "slug": "hvad-koster-koerekort",
      "topic": "cost"
    },
    {
      "slug": "koreprove-ruter",
      "topic": "routes"
    }
  ],
  "EE": [
    {
      "slug": "juhiloa-hind",
      "topic": "cost"
    }
  ],
  "FI": [
    {
      "slug": "ajokortin-hinta",
      "topic": "cost"
    },
    {
      "slug": "ajokoe-reitit",
      "topic": "routes"
    }
  ],
  "FR": [
    {
      "slug": "cout-permis-de-conduire",
      "topic": "cost"
    },
    {
      "slug": "itineraires-examen-conduite",
      "topic": "routes"
    }
  ],
  "GB": [
    {
      "slug": "driving-licence-cost",
      "topic": "cost"
    }
  ],
  "HK": [
    {
      "slug": "cost-of-driving-licence-hong-kong",
      "topic": "cost"
    },
    {
      "slug": "driving-test-routes",
      "topic": "routes"
    }
  ],
  "IE": [
    {
      "slug": "cost-of-driving-licence-ireland",
      "topic": "cost"
    },
    {
      "slug": "driving-test-routes",
      "topic": "routes"
    }
  ],
  "IS": [
    {
      "slug": "hvad-kostar-okuskirteini",
      "topic": "cost"
    }
  ],
  "IT": [
    {
      "slug": "costo-patente-b",
      "topic": "cost"
    },
    {
      "slug": "percorsi-esame-guida",
      "topic": "routes"
    }
  ],
  "JM": [
    {
      "slug": "cost-of-drivers-licence-jamaica",
      "topic": "cost"
    },
    {
      "slug": "road-test-routes",
      "topic": "routes"
    }
  ],
  "JP": [
    {
      "slug": "menkyo-shutoku-hiyou",
      "topic": "cost"
    },
    {
      "slug": "rojou-shiken-course",
      "topic": "routes"
    }
  ],
  "LT": [
    {
      "slug": "vairuotojo-pazymejimo-kaina",
      "topic": "cost"
    }
  ],
  "LU": [
    {
      "slug": "cout-permis-de-conduire-luxembourg",
      "topic": "cost"
    },
    {
      "slug": "itineraires-examen",
      "topic": "routes"
    }
  ],
  "LV": [
    {
      "slug": "cik-maksa-vaditaja-apliecibas-iegusana",
      "topic": "cost"
    },
    {
      "slug": "eksamena-marsruti",
      "topic": "routes"
    }
  ],
  "MT": [
    {
      "slug": "cost-of-driving-licence-malta",
      "topic": "cost"
    },
    {
      "slug": "driving-test-routes",
      "topic": "routes"
    }
  ],
  "NL": [
    {
      "slug": "rijbewijs-kosten",
      "topic": "cost"
    },
    {
      "slug": "examenroute",
      "topic": "routes"
    }
  ],
  "NO": [
    {
      "slug": "hva-koster-forerkort",
      "topic": "cost"
    },
    {
      "slug": "oppkjoring-ruter",
      "topic": "routes"
    }
  ],
  "NZ": [
    {
      "slug": "cost-of-drivers-licence-nz",
      "topic": "cost"
    },
    {
      "slug": "driving-test-routes",
      "topic": "routes"
    }
  ],
  "PT": [
    {
      "slug": "quanto-custa-carta-de-conducao",
      "topic": "cost"
    },
    {
      "slug": "percursos-exame-conducao",
      "topic": "routes"
    }
  ],
  "SE": [
    {
      "slug": "vad-kostar-korkort",
      "topic": "cost"
    },
    {
      "slug": "uppkorning-rutter",
      "topic": "routes"
    }
  ],
  "SG": [
    {
      "slug": "cost-of-driving-licence-singapore",
      "topic": "cost"
    },
    {
      "slug": "driving-test-routes",
      "topic": "routes"
    }
  ],
  "SI": [
    {
      "slug": "cena-vozniskega-izpita",
      "topic": "cost"
    }
  ],
  "TW": [
    {
      "slug": "kaoche-feiyong",
      "topic": "cost"
    },
    {
      "slug": "lukao-luxian",
      "topic": "routes"
    }
  ],
  "US": [
    {
      "slug": "drivers-license-cost-usa",
      "topic": "cost"
    },
    {
      "slug": "road-test-routes",
      "topic": "routes"
    }
  ],
  "ZA": [
    {
      "slug": "cost-of-drivers-licence-south-africa",
      "topic": "cost"
    },
    {
      "slug": "k53-driving-test-routes",
      "topic": "routes"
    }
  ]
};

// Country → guide pages (slug + H1) under /<cc>/guide (GB: /guide).
export const MARKET_GUIDES = {
  "BE": [
    {
      "slug": "eliminerende-fouten-rijexamen",
      "h1": "Eliminerende fouten rijexamen: wanneer ben je meteen gezakt?"
    },
    {
      "slug": "examencentrum-rijbewijs",
      "h1": "Examencentrum rijbewijs kiezen en boeken in Vlaanderen"
    },
    {
      "slug": "praktijkexamen-rijbewijs-b",
      "h1": "Zo verloopt het praktijkexamen rijbewijs B in Vlaanderen"
    },
    {
      "slug": "rijexamen-antwerpen",
      "h1": "Rijexamen Antwerpen: de centra in Deurne en Kontich en hun doorgangspunten"
    },
    {
      "slug": "rijexamen-brussel",
      "h1": "Rijexamen Brussel: Anderlecht, Schaarbeek of toch Vlaanderen?"
    },
    {
      "slug": "rijexamen-gent",
      "h1": "Rijexamen Gent: je praktijkexamen in Sint-Denijs-Westrem voorbereiden"
    },
    {
      "slug": "rijexamen-gezakt",
      "h1": "Rijexamen gezakt: zo plan je je herkansing in Vlaanderen"
    },
    {
      "slug": "rotonde-regels",
      "h1": "Rotonde regels: zo rijd je een Belgische rotonde op je rijexamen"
    },
    {
      "slug": "voorlopig-rijbewijs",
      "h1": "Voorlopig rijbewijs in Vlaanderen: welk model kies je en wat mag je?"
    },
    {
      "slug": "voorrang-van-rechts",
      "h1": "Voorrang van rechts op je rijexamen: zo pas je de regel juist toe"
    },
    {
      "slug": "vrije-begeleiding",
      "h1": "Vrije begeleiding in Vlaanderen: wie mag je begeleider zijn?"
    }
  ],
  "DE": [
    {
      "slug": "autofahren-ueben-ohne-fuehrerschein",
      "h1": "Autofahren üben ohne Führerschein: Wo es legal ist und wo nicht"
    },
    {
      "slug": "fahrpruefung-abbruch",
      "h1": "Fahrprüfung Abbruch: Diese Fehler beenden die Prüfung – und diese nicht"
    },
    {
      "slug": "fahrpruefung-dauer",
      "h1": "Fahrprüfung Dauer: Wie lange die praktische Prüfung 2026 wirklich geht"
    },
    {
      "slug": "fahrpruefung-tipps",
      "h1": "Fahrprüfung Tipps: Die Checkliste für Woche, Vorabend und Prüfungstag"
    },
    {
      "slug": "fahrpruefung-tuev-oder-dekra",
      "h1": "Fahrprüfung TÜV oder DEKRA: Wer in deinem Bundesland prüft"
    },
    {
      "slug": "grundfahraufgaben",
      "h1": "Grundfahraufgaben Klasse B: Welche drei du fährst und wie sie zählen"
    },
    {
      "slug": "pruefungsstrecken-augsburg",
      "h1": "Prüfungsstrecken Augsburg: Was dich in der Fahrprüfung bei TÜV SÜD erwartet"
    },
    {
      "slug": "pruefungsstrecken-dortmund",
      "h1": "Prüfungsstrecken Dortmund: Diese Straßentypen solltest du vor der Prüfung kennen"
    },
    {
      "slug": "pruefungsstrecken-mannheim",
      "h1": "Prüfungsstrecken Mannheim: So bereitest du dich auf die Prüfung bei TÜV SÜD vor"
    },
    {
      "slug": "technische-fragen-fahrpruefung",
      "h1": "Technische Fragen Fahrprüfung: So klappt die Sicherheitskontrolle"
    },
    {
      "slug": "verkehrsuebungsplatz",
      "h1": "Verkehrsübungsplatz: So nutzt du jede Runde vor der Fahrprüfung"
    }
  ],
  "GB": [
    {
      "slug": "automatic-driving-test",
      "h1": "Automatic driving test: what changes, and what your licence lets you drive"
    },
    {
      "slug": "choose-driving-test-centre",
      "h1": "How to choose a driving test centre when you can only move to nearby ones"
    },
    {
      "slug": "driving-test-bad-weather",
      "h1": "Driving test in bad weather: cancellations, rebooking and driving in the rain"
    },
    {
      "slug": "driving-test-faults",
      "h1": "Driving test faults: how minors, serious and dangerous faults are marked"
    },
    {
      "slug": "driving-test-with-a-disability",
      "h1": "Driving test with a disability or learning difficulty: what can be adjusted"
    },
    {
      "slug": "failed-driving-test",
      "h1": "Failed driving test: what to do next, from the debrief to the retake"
    },
    {
      "slug": "how-long-is-a-driving-test",
      "h1": "How long is a driving test? What fills the 35 minutes, part by part"
    },
    {
      "slug": "own-car-driving-test",
      "h1": "Using your own car for your driving test: rules, checks and banned models"
    },
    {
      "slug": "supervising-a-learner-driver",
      "h1": "Supervising a learner driver: the rules, and how to practise for the test"
    },
    {
      "slug": "undue-hesitation-driving-test",
      "h1": "Undue hesitation: when driving too cautiously costs you the test"
    },
    {
      "slug": "when-you-pass-your-driving-test",
      "h1": "What happens when you pass your driving test, and what to sort out next"
    }
  ],
  "NL": [
    {
      "slug": "bijzondere-verrichtingen-auto",
      "h1": "Bijzondere verrichtingen auto: zo laat je ze zien op je CBR-examen"
    },
    {
      "slug": "cbr-praktijkexamen",
      "h1": "CBR praktijkexamen B: wat er gebeurt van ontvangst tot uitslag"
    },
    {
      "slug": "examenroutes-amsterdam",
      "h1": "Examenroutes Amsterdam: zo oefen je voor CBR Amsterdam aan de Naritaweg"
    },
    {
      "slug": "examenroutes-rijswijk",
      "h1": "Examenroutes Rijswijk: voorbereiden op CBR Lange Kleiweg bij Den Haag"
    },
    {
      "slug": "examenroutes-rotterdam",
      "h1": "Examenroutes Rotterdam: voorbereiden op het CBR aan de Noorderbocht"
    },
    {
      "slug": "faalangstexamen-cbr",
      "h1": "Faalangstexamen CBR: rijexamen met meer tijd en een time-out"
    },
    {
      "slug": "hoe-lang-duurt-het-rijexamen",
      "h1": "Hoe lang duurt het rijexamen, en hoe lang wacht je erop?"
    },
    {
      "slug": "makkelijkste-cbr-locatie",
      "h1": "De makkelijkste CBR-locatie: bestaat die, en welke past bij jou?"
    },
    {
      "slug": "rijbewijs-halen",
      "h1": "Rijbewijs halen: in 7 stappen van eerste les naar je eigen pasje"
    },
    {
      "slug": "rijexamen-gezakt",
      "h1": "Rijexamen gezakt: wat je nu doet en wanneer je weer mag"
    },
    {
      "slug": "rijexamen-tips",
      "h1": "Rijexamen tips: van vier weken vooraf tot het moment van de uitslag"
    }
  ],
  "NO": [
    {
      "slug": "forerproven-klasse-b",
      "h1": "Førerprøven klasse B: slik foregår oppkjøringen fra start til resultat"
    },
    {
      "slug": "glattkjoring-sikkerhetskurs-pa-bane",
      "h1": "Glattkjøring (sikkerhetskurs på bane): dette skjer på kurset"
    },
    {
      "slug": "langkjoring-sikkerhetskurs-pa-vei",
      "h1": "Langkjøring og sikkerhetskurs på vei: slik er de 13 timene bygd opp"
    },
    {
      "slug": "nervos-for-oppkjoring",
      "h1": "Nervøs før oppkjøring: slik får du kontroll over nervene"
    },
    {
      "slug": "oppkjoring-tips",
      "h1": "Oppkjøring tips: sjekklisten som gjør prøvedagen forutsigbar"
    },
    {
      "slug": "oppkjoringsruter-alesund",
      "h1": "Oppkjøringsruter Ålesund: forbered deg til Ålesund trafikkstasjon"
    },
    {
      "slug": "oppkjoringsruter-arendal",
      "h1": "Oppkjøringsruter Arendal: forbered deg til Arendal trafikkstasjon på Stoa"
    },
    {
      "slug": "oppkjoringsruter-fredrikstad",
      "h1": "Oppkjøringsruter Fredrikstad: øv rundt Hafslund trafikkstasjon"
    },
    {
      "slug": "oppkjoringsruter-hamar",
      "h1": "Oppkjøringsruter Hamar: slik blir du klar for oppkjøring på Hedmarken"
    },
    {
      "slug": "oppkjoringsruter-haugesund",
      "h1": "Oppkjøringsruter Haugesund: slik blir du trygg på veiene rundt stasjonen"
    },
    {
      "slug": "ovelseskjoring-regler",
      "h1": "Øvelseskjøring regler: dette gjelder for elev, ledsager og bil"
    }
  ],
  "SE": [
    {
      "slug": "boka-uppkorning",
      "h1": "Boka uppkörning: krav, steg, avgifter och avbokningsregler"
    },
    {
      "slug": "ovningskora-privat",
      "h1": "Övningsköra privat utan introduktionsutbildning: det här gäller"
    },
    {
      "slug": "ovningskorning-infor-korprovet",
      "h1": "Övningskörning som förbereder dig för körprovet"
    },
    {
      "slug": "riskutbildning-riskettan-risktvaan",
      "h1": "Riskutbildning för B-körkort: riskettan, risktvåan och giltighet"
    },
    {
      "slug": "sakerhetskontroll-korkort",
      "h1": "Säkerhetskontroll körkort B: lampor, bromsar, däck och vätskor"
    },
    {
      "slug": "underkand-pa-uppkorningen",
      "h1": "Underkänd på uppkörningen: giltighetstider, omprov och nästa steg"
    },
    {
      "slug": "uppkorning-b-sa-gar-korprovet-till",
      "h1": "Uppkörning för B-körkort: så går Trafikverkets körprov till"
    },
    {
      "slug": "uppkorning-tips",
      "h1": "Uppkörning tips: checklista från veckan före till sista korsningen"
    },
    {
      "slug": "uppkorningsrutter-goteborg",
      "h1": "Uppkörningsrutter Göteborg: så skiljer sig de tre förarprovskontoren"
    },
    {
      "slug": "uppkorningsrutter-malmo",
      "h1": "Uppkörningsrutter Malmö: öva inför körprovet på Cederströmsgatan"
    },
    {
      "slug": "uppkorningsrutter-stockholm",
      "h1": "Uppkörningsrutter Stockholm: Farsta, Järfälla, Södertälje och Upplands Väsby"
    }
  ],
  "SI": [
    {
      "slug": "izpit-iz-voznje",
      "h1": "Kako poteka izpit iz vožnje: od preverjanja listin do ocene"
    },
    {
      "slug": "izpitne-poti",
      "h1": "Izpitne poti brez skrivnosti: kaj mora vsebovati vožnja na izpitu"
    },
    {
      "slug": "izpitni-center-celje",
      "h1": "Vozniški izpit Celje: kaj moraš vedeti o izpitnem centru v Ljubečni"
    },
    {
      "slug": "izpitni-center-kranj",
      "h1": "Vozniški izpit Kranj: kako ga načrtuješ ob dolgi čakalni dobi"
    },
    {
      "slug": "izpitni-center-maribor",
      "h1": "Vozniški izpit Maribor: kako se pripraviš v izpitnem centru na Cesti k Tamu"
    },
    {
      "slug": "kdaj-pades-na-vozniskem-izpitu",
      "h1": "Kdaj padeš na vozniškem izpitu in katere napake ocenjevalec še dopusti"
    },
    {
      "slug": "ponovni-izpit-iz-voznje",
      "h1": "Padel si? Ponovni izpit iz vožnje korak za korakom"
    },
    {
      "slug": "pregled-vozila-na-vozniskem-izpitu",
      "h1": "Pregled vozila na vozniškem izpitu: kaj pokažeš v kabini in pod pokrovom"
    },
    {
      "slug": "voznisko-dovoljenje-b",
      "h1": "Vozniško dovoljenje B v Sloveniji: od zdravniškega pregleda do izpita iz vožnje"
    },
    {
      "slug": "voznja-po-avtocesti-na-izpitu",
      "h1": "Vožnja po avtocesti na izpitu iz vožnje: priključek, pasovi in izvoz"
    },
    {
      "slug": "voznja-s-spremljevalcem",
      "h1": "Vožnja s spremljevalcem: kdo sme voziti, kdo sme spremljati in kako začneš"
    }
  ]
};

export function guidesFor(code) {
  return MARKET_GUIDES[String(code || '').toUpperCase()] || [];
}

export function pillarsFor(code) {
  return MARKET_PILLARS[String(code || '').toUpperCase()] || [];
}

// First pillar of a given topic for a country (e.g. costPillar('GB') → cost guide).
export function pillarByTopic(code, topic) {
  return pillarsFor(code).find(p => p.topic === topic) || null;
}
